<template>
    <div class="pb-5">
      <nav-bar/>
      <!-- Sub navbar -->
      <nav class="navbar">
        <div class="container px-0 mx-0 justify-content-start">
          <div class="input-group col-7">
            <div class="btn-group mr-3" role="group" aria-label="Basic outlined example">
              <button type="button" :class="`btn ${mode === 'users' ? 'btn-secondary' : 'btn-outline-secondary'}`" @click="setMode('users')">{{ $t('Users.title') }}</button>
              <button type="button" :class="`btn ${mode === 'trucks' ? 'btn-secondary' : 'btn-outline-secondary'}`" @click="setMode('trucks')">{{ $t('Vehicles.trucks') }}</button>
              <button type="button" :class="`btn ${mode === 'trailers' ? 'btn-secondary' : 'btn-outline-secondary'}`" @click="setMode('trailers')">{{ $t('Vehicles.trailers') }}</button>
              <button type="button" :class="`btn ${mode === 'inactiveUsers' ? 'btn-secondary' : 'btn-outline-secondary'}`" @click="setMode('inactiveUsers')">{{ $t('Users.inactiveTitle') }}</button>
            </div>
            <button v-if="mode === 'users' && isAdmin && !isViewer" class="btn btn-kne-orange" @click="triggerAddUser" type="button">{{$t('UsersVehicles.addUser')}}</button>
            <button v-if="mode === 'trucks' && !isViewer" class="btn btn-kne-orange" @click="triggerAddTruck" type="button">{{$t('UsersVehicles.addTruck')}}</button>
            <button v-if="mode === 'trailers' && !isViewer" class="btn btn-kne-orange" @click="triggerAddTrailer" type="button">{{$t('UsersVehicles.addTrailer')}}</button>
          </div>
        </div>
      </nav>
      
      <div v-if="mode === 'users'">
        <users />
      </div>
      <div v-if="mode === 'inactiveUsers'">
        <users inactive />
      </div>
      <div v-if="mode === 'trucks'">
        <trucks />
      </div>
      <div v-if="mode === 'trailers'">
        <trailers />
      </div>
  
    </div>
  </template>
  
  <script>
  // import _ from 'lodash'
  import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
  import hoverToolTip from '../module/basic-components/hoverToolTip.vue'
  import regularSelect from '../module/basic-components/regularSelect.vue'
  import Users from './Users.vue'
  import Trucks from './Trucks.vue'
  import Trailers from './Trailers.vue'
  
  export default {
    name: 'UsersVehiclesWrapper',
  
    components: {
      SidebarToggleButton,
      hoverToolTip,
      regularSelect,
      Users,
      Trucks,
      Trailers
    },
  
    data () {
      return {
        mode: 'users'
      }
    },
  
    methods: {
      setMode (mode) {
        this.mode = mode
      },

      triggerAddUser () {
        this.$emit('open-add-user-modal')
      },

      triggerAddTruck () {
        this.$emit('open-add-truck-modal')
      },

      triggerAddTrailer () {
        this.$emit('open-add-trailer-modal')
      },

      onResize: window._.debounce(function () {
        this.isScreenSmall = window.innerWidth < 800
      }, 50)
    },

    computed: {
      isAdmin () {
        return this.$store.state.authorization.role === 'Admin'
      },
      isViewer () {
        return this.$store.state.authorization.role === 'Viewer'
      }
    },
  
    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
    },
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    .no-outline {
      outline: none;
    }
  </style>
